// Типові дані автопарку для макетів (замість API)
const BRANDS = ["Toyota", "Skoda", "Volkswagen", "Hyundai", "Kia", "Škoda", "Dacia"];
const MODELS = {
  Toyota: ["Corolla", "Camry", "Yaris", "Prius"],
  Skoda: ["Octavia", "Superb", "Fabia", "Rapid"],
  Škoda: ["Octavia", "Superb", "Fabia", "Rapid"],
  Volkswagen: ["Passat", "Golf", "Polo", "Tiguan"],
  Hyundai: ["i30", "i20", "Tucson", "Kona"],
  Kia: ["Ceed", "Sportage", "Rio", "Niro"],
  Dacia: ["Duster", "Sandero", "Logan"]
};
const COLORS = ["Biały", "Czarny", "Szary", "Niebieski", "Srebrny", "Czerwony"];
const STATUSES = ["active", "inactive", "maintenance", "under_payment"];

const getModel = (brand) => {
  const models = MODELS[brand] || MODELS["Toyota"];
  return models[Math.floor(Math.random() * models.length)];
};

const randomVin = () => {
  const chars = "ABCDEFGHJKLMNPRSTUVWXYZ0123456789";
  let s = "";
  for (let i = 0; i < 17; i++) s += chars[Math.floor(Math.random() * chars.length)];
  return s;
};

const randomPlate = () => {
  const letters = "ABCDEFGHIJKLMNOPRSTUWXYZ";
  const len = Math.random() > 0.5 ? 3 : 2;
  let a = "";
  for (let i = 0; i < len; i++) a += letters[Math.floor(Math.random() * letters.length)];
  const numLen = len === 3 ? 4 : 5;
  const max = Math.pow(10, numLen) - 1;
  const n = String(Math.floor(Math.random() * max) + 1).padStart(numLen, "0");
  return `${a} ${n}`;
};

const FIRST_NAMES = ["Jan", "Andrzej", "Piotr", "Krzysztof", "Stanisław", "Tomasz", "Paweł"];
const LAST_NAMES = ["Kowalski", "Wiśniewski", "Wójcik", "Kowalczyk", "Kamiński", "Lewandowski"];

const randomFutureDate = (monthsFromNowMin, monthsFromNowMax) => {
  const d = new Date();
  const months = monthsFromNowMin + Math.random() * (monthsFromNowMax - monthsFromNowMin);
  d.setMonth(d.getMonth() + Math.floor(months));
  return d.toISOString().slice(0, 10);
};

export const generateMockVehicles = (count = 12) => {
  const list = [];
  const usedPlates = new Set();
  for (let i = 0; i < count; i++) {
    let plate = randomPlate();
    while (usedPlates.has(plate)) plate = randomPlate();
    usedPlates.add(plate);
    const brand = BRANDS[Math.floor(Math.random() * BRANDS.length)];
    const driverIndex = Math.floor(Math.random() * FIRST_NAMES.length);
    list.push({
      id: `fleet-${i + 1}`,
      plate,
      brand,
      model: getModel(brand),
      year: 2018 + Math.floor(Math.random() * 6),
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      vin: randomVin(),
      status: STATUSES[Math.floor(Math.random() * STATUSES.length)],
      driverName: Math.random() > 0.2 ? `${FIRST_NAMES[driverIndex]} ${LAST_NAMES[driverIndex]}` : null,
      notes: Math.random() > 0.6 ? "Przegląd wykonany" : "",
      insuranceEndDate: randomFutureDate(-3, 12),
      toEndDate: randomFutureDate(-2, 14)
    });
  }
  return list;
};

/** Format YYYY-MM-DD to compact PL dd.mm.yy */
export const formatDateCompact = (isoDate) => {
  if (!isoDate) return "–";
  const [y, m, d] = isoDate.split("-");
  return `${d}.${m}.${y.slice(2)}`;
};

/** Days from today until date (negative if past). Date at start of day. */
export const daysUntil = (isoDate) => {
  if (!isoDate) return null;
  const [y, m, d] = isoDate.split("-").map(Number);
  const end = new Date(y, m - 1, d);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  return Math.floor((end - today) / (24 * 60 * 60 * 1000));
};

/** Bootstrap text class by expiry: >3m green, 1–3m yellow, <1m or past red */
export const expiryTextClass = (isoDate) => {
  const days = daysUntil(isoDate);
  if (days == null) return "";
  if (days >= 90) return "text-success";
  if (days >= 30) return "text-warning";
  return "text-danger";
};

export const STATUS_LABELS = {
  active: "Aktywny",
  inactive: "Nieaktywny",
  maintenance: "W naprawie",
  under_payment: "Pod wypłatą"
};

/** Генерує випадкові транзакції виплат (для макету). */
export const generateMockInstallmentTransactions = (installmentData, count = 10) => {
  const { pricePerWeek = 500, weeks = 52, createdAt } = installmentData || {};
  const start = createdAt ? new Date(createdAt) : new Date();
  start.setDate(start.getDate() - count * 7);
  const list = [];
  let balance = (installmentData?.totalPrice || 30000) - (installmentData?.initialDeposit || 5000);
  for (let i = 0; i < count; i++) {
    const date = new Date(start);
    date.setDate(date.getDate() + i * 7);
    const amount = pricePerWeek + (Math.random() > 0.7 ? 0 : Math.round((Math.random() - 0.5) * 100));
    balance -= amount;
    const weekNum = i + 1;
    list.push({
      id: `tx-${i + 1}`,
      date: date.toISOString().slice(0, 10),
      amount,
      type: "Rata",
      note: `Rata przy rozliczeniu za tydzień ${String(weekNum).padStart(2, "0")}`,
      balance: Math.max(0, Math.round(balance))
    });
  }
  return list.sort((a, b) => b.date.localeCompare(a.date));
};

/** Повертає макет початкових даних wypłaty, якщо у авто немає збережених. */
export const getMockInstallmentData = (vehicle) => ({
  driverName: vehicle?.driverName || "–",
  totalPrice: 45000 + Math.floor(Math.random() * 15000),
  initialDeposit: 3000 + Math.floor(Math.random() * 4000),
  pricePerWeek: 400 + Math.floor(Math.random() * 200),
  weeks: 52 + Math.floor(Math.random() * 52),
  createdAt: (() => {
    const d = new Date();
    d.setMonth(d.getMonth() - Math.floor(Math.random() * 6));
    return d.toISOString().slice(0, 10);
  })()
});

// Простий store для макету: список з таблиці зберігається тут, форма редагування його читає
let mockFleetStore = null;
export const setMockFleetStore = (list) => { mockFleetStore = list; };
export const getMockFleetStore = () => mockFleetStore;
